
import PrismicData from '~/assets/js/prismic-controller.js'
import ChatbotTrigger from '~/components/ChatbotTrigger.vue'
import ContactForm from '~/components/ContactForm.vue'

export default {
  name: 'Contact',
  nuxtI18n: {
    paths: {
      en: '/contact',
      it: '/contatti',
      de: '/kontakt'
    }
  },
  computed: {
    isApp() { return this.$route.query.app }
  },
  components: { ContactForm, ChatbotTrigger },
  async asyncData({$prismic, app, error, req, store }) {
    const lang = app.i18n.locales.filter(i =>
      i.iso.includes(app.i18n.locale)
    )[0].iso
    try {
      const result = await $prismic.api.getSingle('contact', { lang })
      return {
        document: result.data,
        documentUid: result.uid,
        documentLang: result.lang.substr(0, 2)
      }
    } catch (e) {
      error({ statusCode: 404, message: JSON.stringify(e) })
    }
  },
  data() {
    return {
      pressKitUrl:
        'https://drive.google.com/drive/folders/1yUBSQoycb6UOGSj4BxflAMqiPRfnTcaa',
      pitchDeckUrl:
        'https://drive.google.com/file/d/1q-xNwNtgw5m9TD_ZDB5C6_bydaOnspP3/view',
    }
  },
  head() {
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), this.document, this.documentUid, this.documentLang)
  }
}
